// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dc5HQ","paragraph":"styles_paragraph__R7lHf"};